export default "__VITE_ASSET__CmSidOiL__"